import { createRouter, createWebHistory } from 'vue-router'
import { showNotify } from 'vant';

const routes = [
  {
    path: '/',
    name: 'main',
    meta: { title: '首页' },
    component: () => import('../views/Main.vue')
  },
  {
    path: '/neworder',
    name: 'neworder',
    meta: { title: '门市下单' },
    component: () => import('../views/NewOrder.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '浙江丽芙秀化妆品有限公司' },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/demo2',
    name: 'demo2',
    meta: { title: '演示2' },
    component: () => import('../views/Demo2.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//路由切换前事件
router.beforeEach((to, from, next) => {
  //next(); //路由继续下去
  
  if (to.name != 'login') 
  {
    if (localStorage.getItem('Token')) {
      next();//路由继续下去
    } else {
      router.push('/login');
    }
  }else{
     next(); //路由继续下去
  }
 
})
//路由切换后事件
router.afterEach((to, from) => {
  document.title = to.meta.title
})
 
export default router
